import { RefinementListItem } from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";

export const DEFAULT_SEPARATOR = " • ";

export const defaultSelectedValuesLabel = (items: RefinementListItem[]) => {
  return items.map((i) => i.label).join(DEFAULT_SEPARATOR);
};
